export const MESSAGE_PROPS = {
  id: 'job-message',
  className:
    'py-3 px-4 rounded-lg bg-neutral-100 text-style-g text-neutral-900 mb-6 whitespace-pre-line break-all',
};
